import React from 'react';

import { observable } from 'mobx';

import createContext from 'bz-utilities/hooks/context-v2';

class AddStore {
  @observable description: string = '';
}

export const [AddStoreContext, useAddStore] = createContext<AddStore>('AddStore');

export const AddStoreProvider: React.FC<React.PropsWithChildren> = React.memo(({ children }) => {
  const [store] = React.useState(() => new AddStore());

  return <AddStoreContext.Provider value={store}>{children}</AddStoreContext.Provider>;
});

AddStoreProvider.displayName = 'AddStoreProvider';

export default AddStore;
